<template>
  <div class="paperwork-container">
    <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions"></OnboardingMenu>
    <div class="banner">
      <img :src="bannerUrl" alt="">
    </div>
    <onboarding-message class="message" :messages="messages"></onboarding-message>
    <div class="title">{{ $t('onboarding.common.questionnaireFinished') }}</div>
    <div class="subtitle">{{ employeeName }}</div>
    <onboarding-divider />
    <ul class="step-zero-div">
      <li>{{ $t('onboarding.common.questionnaireFinishedText1') }}</li>
    </ul>
    <div class="next-button">
      <onboarding-button v-if="showHomeBtn" type='normal' width="large" :text="$t('onboarding.common.toHomeBtn')" @click.native="goToHomePage"></onboarding-button>
    </div>
  </div>
</template>
<script>
import OnboardingDivider from '@/components/onboarding/form/Divider'
import OnboardingButton from '@/components/onboarding/form/Button'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import OnboardingMessage from '@/components/onboarding/form/Message'
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingDivider, OnboardingButton, OnboardingMenu, OnboardingMessage
  },
  data () {
    return {
      bannerUrl: '',
      employeeName: '',
      showHomeBtn: false
    }
  },
  computed: {

  },
  created () {
    this.bannerUrl = this.$parent.headerImage
    this.employeeName = this.getCurrentAccount().full_name
    if (this.$parent.invitationInfo.microsite_url) {
      this.showHomeBtn = true
    }
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    goToHomePage () {
      this.$router.push(this.$parent.getOnboardingHomePath())
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
  .paperwork-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .banner {
        img {
          background-size: cover;
          width: 100%;
          height: auto;
        }
    }
    .message {
      position: fixed;
      top: 50px;
    }
    .title {
      font-weight: bolder;
      margin-top: 2rem;
      margin-bottom: 1.2rem;
      text-align: center;
    }
    .subtitle {
      text-align: center;
      color: gray;
    }
    .divider {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2.5rem;
      float: none;
    }
    .empty-div {
      height: 50px;
    }
    .step-zero-div {
      width: 75%;
      color: gray;

      li {
        margin: 2rem 0;
        list-style-type: disc;
        font-size: smaller !important;
      }
    }
    .next-button {
      width: 100%;
      margin: 4rem 2.5rem 4rem 0;
      padding-bottom: 100px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .next-button {
      width: 40% !important;
    }
    .steps-component {
      margin-bottom: 100px !important;
    }
    .step-zero-div {
      width: 40% !important;
      li {
        list-style-type: disc;
        margin-top: 30px !important;
        font-size: smaller !important;
      }
    }
}
</style>
